/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ token: NonNullable<unknown> }} Sitesettings_Hint_Year1Inputs */

const vi_sitesettings_hint_year1 = /** @type {(inputs: Sitesettings_Hint_Year1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.token} được thay bằng năm hiện tại.`)
};

/**

* @param {Sitesettings_Hint_Year1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_hint_year1 = /** @type {((inputs: Sitesettings_Hint_Year1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Hint_Year1Inputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_hint_year1(inputs)
});
export { sitesettings_hint_year1 as "siteSettings_hint_year" }